import {
  LOGIN_USER,
  LOGOUT_USER,
  SET_USER_ERROR,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAIL,
} from "../actions/userActions";

const initialState = {
  isAuthenticated: false,
  userData: null,
  error: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      console.log("User Data Payload:", action.payload.user); // Logging user data untuk verifikasi

      return {
        ...state,
        isAuthenticated: true,
        userData: action.payload.user, // Pastikan payload.user memiliki id
        error: null,
      };
    case LOGOUT_USER:
      return {
        ...state,
        isAuthenticated: false,
        userData: null,
        error: null,
      };
    case SET_USER_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        userData: action.payload.user, // Pastikan payload.user memiliki data pengguna
        error: null,
      };
    case REGISTER_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
